export function urlencodeFormData(FormData){
  let params = new URLSearchParams();
  
  for(let pair of FormData.entries()){
      typeof pair[1] == 'string' && params.append(pair[0], pair[1]);
  }
  
  return params.toString();
}
